import { FeedAdviceType } from 'src/app/feed-advice/models/feed-advice.model';

export const FEEDADVICETYPES = [
  {
    name: FeedAdviceType.FATTENING,
    period: '20 weeks',
    type: 'week',
  },
  {
    name: FeedAdviceType.REARING,
    period: '30 weeks',
    type: 'week',
  },
  {
    name: FeedAdviceType.SOWS_BREEDTOFARROW,
    period: '',
    type: 'week',
  },
  {
    name: FeedAdviceType.SOWS_FARROWTOWEAN,
    period: '',
    type: 'week',
  },
  {
    name: FeedAdviceType.SOWS_WEANTOBREED,
    period: '',
    type: 'week',
  },
  {
    name: FeedAdviceType.WEANED_PIGLETS,
    period: '',
    type: 'week',
  },
];
